module.exports = __webpack_public_path__ + "static/media/MOSFET Board Kit 1.f5d7103e.jpg";